import { AxiosResponse } from 'axios';
import cacheableRequest from '../../../services/cacheableRequest';

export type OrgMembership = {
  _id: string;
  org: { id: string; name: string; owner: { id: string } };
  user: { id: string; email: string };
};

export const getMemberByEmail = (email: string) => {
  const encodedEmail = encodeURIComponent(email);

  return cacheableRequest(`/v1/organizations/users/${encodedEmail}/email`).then(
    ({ data }: AxiosResponse<OrgMembership[]>) => data
  );
};
